 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TITLE from '@/components/title'
 import COPYRIGHT from '@/components/copyright'
 import DEDICATION from '@/components/dedication'
 import TOC from '@/components/toc'
 import ILLUSTRATION001 from '@/components/illustration001'
 import PREFACE from '@/components/preface'
 import ACKNOWLEDGEMENTS from '@/components/acknowledgements'
 import MAP001 from '@/components/map001'
 import CHAPTER001 from '@/components/chapter001'
 import CHAPTER002 from '@/components/chapter002'
 import CHAPTER003 from '@/components/chapter003'
 import CHAPTER004 from '@/components/chapter004'
 import CHAPTER005 from '@/components/chapter005'
 import CHAPTER006 from '@/components/chapter006'
 import ILLUSTRATION002 from '@/components/illustration002'
 import CHAPTER007 from '@/components/chapter007'
 import CHAPTER008 from '@/components/chapter008'
 import CHAPTER009 from '@/components/chapter009'
 import CHAPTER010 from '@/components/chapter010'
 import CHAPTER011 from '@/components/chapter011'
 import CHAPTER012 from '@/components/chapter012'
 import CHAPTER013 from '@/components/chapter013'
 import CHAPTER014 from '@/components/chapter014'
 import BIBLIOGRAPHY from '@/components/bibliography'
 import INDEX from '@/components/index'
 import END from '@/components/end'
 import ALSOAVAILABLE from '@/components/alsoavailable'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/title",
 			"name" : "title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/dedication",
 			"name" : "dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/illustration001",
 			"name" : "illustration001",
 			"component" : ILLUSTRATION001
 		},
 		{
 			"path" : "/preface",
 			"name" : "preface",
 			"component" : PREFACE
 		},
 		{
 			"path" : "/acknowledgements",
 			"name" : "acknowledgements",
 			"component" : ACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/map001",
 			"name" : "map001",
 			"component" : MAP001
 		},
 		{
 			"path" : "/chapter001",
 			"name" : "chapter001",
 			"component" : CHAPTER001
 		},
 		{
 			"path" : "/chapter002",
 			"name" : "chapter002",
 			"component" : CHAPTER002
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js